import { useState, useEffect } from "react";
import { isNumber } from "../../Utils/Common";
import MyComponent from "./MyComponent";        // renamed from MoneyTransfer
import { Tabs, Modal } from "antd";
import PayoutHistory2 from "../reports/fundTransferReport";
import PropagateLoader from "react-spinners/PropagateLoader";
import { postRequest } from "../../Utils/AppApi";
import {
  POST_FUND_TRANSFER_CUSTOMER_DETAILS,   // or POST_PAYOUT_CUSTOMER_DETAIL – use the one you need
  MOBILE_SEND_OTP,
  MOBILE_SEND_VERFIY,
} from "./../../Utils/appConstants";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

const { TabPane } = Tabs;

const IndexComponent = () => {
  const history = useHistory();
  const tabPosition = "left";
  const [searchText, setSearchText] = useState(null);
  const [defaultKey, setDefaultKey] = useState("1");
  const [isLoading, setLoading] = useState(false);
  const [customerInfo, setCustomerInfo] = useState(null);
  const [customerNotExist, setCustomerNotExist] = useState(false);
  const [searchButton, setSearchButton] = useState(true);
  const [isOtpModal, setOtpModal] = useState(false);
  const [isOtpNumberValue, setOtpNumberValue] = useState(null);

  useEffect(() => {}, []);

  const onChangeHandler = (value) => {
    setDefaultKey(value);
  };

  const handleSearch = (e) => {
    const val = e.target.value;
    if (val.length === 10) {
      setSearchButton(false);
      setCustomerInfo(null);
      setCustomerNotExist(false);
    } else {
      setSearchButton(true);
      setCustomerInfo(null);
      setCustomerNotExist(false);
    }
    setSearchText(val);
  };

  // Fetch customer details – uses the same API as MyComponent
  const getCustomerInfo = async () => {
    if (!searchText || searchText.length !== 10) return;
    setLoading(true);
    const payload = { customerMobile: searchText, detail_for: "quickSettlement" };
    try {
      const response = await postRequest(
        POST_FUND_TRANSFER_CUSTOMER_DETAILS,
        payload,
        history
      );
      if (response.success === true) {
        if (response.data) {
          setCustomerInfo(response.data);
          setCustomerNotExist(false);
        } else {
          setCustomerNotExist(true);
          toast.error(response.message || "No customer data found");
        }
      } else {
        setCustomerNotExist(true);
        toast.error(response.message || "Customer not found");
      }
    } catch (error) {
      console.log(error);
      setCustomerNotExist(true);
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyMobileNumber = () => {
    if (!searchText || searchText.length !== 10) {
      toast.warning("Please enter a 10‑digit mobile number");
      return;
    }
    setLoading(true);
    const payload = { mobile: searchText, isremittance: true };
    postRequest(MOBILE_SEND_OTP, payload, history)
      .then((response) => {
        if (response.success === true) {
          toast.success(response.message);
          setOtpModal(true);
        } else {
          toast.error(response.message);
        }
      })
      .catch((error) => console.log(error))
      .finally(() => setLoading(false));
  };

  const handleVerifyOtpMobileNumber = () => {
    if (!isOtpNumberValue) {
      toast.warning("Please enter OTP");
      return;
    }
    setLoading(true);
    const payload = {
      mobile: searchText,
      otp: isOtpNumberValue,
    };
    postRequest(MOBILE_SEND_VERFIY, payload, history)
      .then((response) => {
        if (response.success === true) {
          toast.success(response.message);
          setOtpNumberValue(null);
          setOtpModal(false);
          getCustomerInfo();
        } else {
          toast.error(response.message);
        }
      })
      .catch((error) => console.log(error))
      .finally(() => setLoading(false));
  };

  const handleHideModal = () => {
    setOtpModal(false);
    setOtpNumberValue(null);
  };

  if (isLoading) {
    return (
      <div className="content text-center" style={{ margin: "250px 0" }}>
        <PropagateLoader color="#5851D2" loading={isLoading} size={25} />
      </div>
    );
  }

  return (
    <div>
      <div className="content-wrapper">
        <div className="row">
          <div className="col-md-12">
            <div className="card rounded-0 p-3">
              <Tabs
                defaultActiveKey={defaultKey}
                tabPosition={tabPosition}
                onTabScroll={"right"}
                onChange={(key) => onChangeHandler(key)}
              >
                <TabPane tab={`Home`} key="1">
                  <div className="h-100">
                    <div className="row mb-3">
                      <div className="input-group">
                        <div className="col-md-2"></div>
                        <div className="col-md-4">
                          <input
                            className="form-control py-2 border"
                            type="search"
                            value={searchText || ""}
                            onKeyDown={isNumber}
                            placeholder="Enter Customer mobile..."
                            maxLength={10}
                            onChange={handleSearch}
                          />
                        </div>
                        <button
                          onClick={handleVerifyMobileNumber}
                          className="btn btn-primary ml-3 border-left-0 border"
                          disabled={searchButton}
                          type="button"
                        >
                          <i className="fa fa-search" /> Search
                        </button>
                      </div>
                    </div>

                    {/* Render the child component with props – it will show AddCustomer or ViewCustomer */}
                    {(customerInfo || customerNotExist) && (
                      <MyComponent
                        mobile={searchText}
                        customerInfo={customerInfo}
                        customerNotExist={customerNotExist}
                        findCustomerInfo={getCustomerInfo}
                      />
                    )}
                  </div>
                </TabPane>

                <TabPane tab={`History`} key="4">
                  <div className="h-100">
                    <PayoutHistory2 />
                  </div>
                </TabPane>
              </Tabs>
            </div>
          </div>
        </div>
      </div>

      {/* OTP Modal */}
      <Modal
        title="Verify Mobile Number"
        width={600}
        open={isOtpModal}
        onOk={handleVerifyOtpMobileNumber}
        onCancel={handleHideModal}
        footer={null}
      >
        <div className="row">
          <div className="col-md-12 form-group">
            <label>OTP Code: </label>
            <input
              type="text"
              className="form-control"
              onChange={(e) => setOtpNumberValue(e.target.value)}
              maxLength={4}
              value={isOtpNumberValue || ""}
              onKeyDown={isNumber}
            />
          </div>
          <div className="col-md-12 form-group text-right">
            <button
              type="button"
              onClick={handleHideModal}
              className="btn btn-sm btn-default mr-2"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleVerifyOtpMobileNumber}
              className="btn btn-sm btn-primary"
            >
              Verify
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default IndexComponent;